export default "__VITE_ASSET__BAhfZqB3__"